import React from 'react';
import { AvatarContainer ,Text} from './Avatar.styled';

const Avatar = (props) => {
    return <AvatarContainer>
        <Text>{props.intials}</Text>
    </AvatarContainer>;
};

export default Avatar;
